export const rules = [
  {
    English: [
      {
        head: "Rules",
        description: `The test consists of !!!count!!! questions, where each question offers four answer options. Remember that only one of these options is correct. You have !!!count2!!! minutes to complete the test, so it's recommended to choose your answers quickly but carefully. Considering the varying difficulty of the questions, you can earn between 2 to 4 points for a correct answer. Note that if you don't finish the test within the allotted time, it will automatically end. You will be able to review the test results immediately after its completion.`,
        buttonCancel: "Cancel",
        buttonGo: "Start",
      },
    ],
    Ukrainian: [
      {
        head: "Правила",
        description: `Тест складається з !!!count!!! запитань, де кожне запитання пропонує чотири варіанти відповідей. Пам'ятайте, що лише один з цих варіантів є правильним. На виконання тесту вам дається !!!count2!!! хвилин, тож рекомендую вибирати відповіді швидко, але уважно. Враховуючи різну складність запитань, за правильну відповідь можна отримати від 2 до 4 балів. Зверніть увагу на те, що якщо ви не завершите тест протягом відведеного часу, він автоматично завершиться. Результати тесту ви зможете переглянути одразу після його завершення.`,
        buttonCancel: "Відмінити",
        buttonGo: "Почати",
      },
    ],
    Polish: [
      {
        head: "Zasady",
        description: `Test składa się z !!!count!!! pytań, gdzie każde pytanie oferuje cztery opcje odpowiedzi. Pamiętaj, że tylko jedna z tych opcji jest poprawna. Masz !!!count2!!! minut na ukończenie testu, więc zaleca się wybieranie odpowiedzi szybko, ale ostrożnie. Biorąc pod uwagę różny poziom trudności pytań, za poprawną odpowiedź można zdobyć od 2 do 4 punktów. Zwróć uwagę, że jeśli nie ukończysz testu w wyznaczonym czasie, test automatycznie się zakończy. Wyniki testu będzie można przejrzeć natychmiast po jego zakończeniu.`,
        buttonCancel: "Anulować",
        buttonGo: "Zacząć",
      },
    ],
    German: [
      {
        head: "Regeln",
        description: `Der Test besteht aus !!!count!!! Fragen, wobei jede Frage vier Antwortmöglichkeiten bietet. Denken Sie daran, dass nur eine dieser Optionen korrekt ist. Sie haben !!!count2!!! Minuten Zeit, um den Test abzuschließen, daher empfiehlt es sich, Ihre Antworten schnell, aber sorgfältig auszuwählen. Abhängig vom Schwierigkeitsgrad der Fragen können Sie für eine richtige Antwort zwischen 2 und 4 Punkte erhalten. Beachten Sie, dass der Test automatisch endet, wenn Sie ihn nicht innerhalb der vorgegebenen Zeit abschließen. Die Testergebnisse können Sie sofort nach Abschluss einsehen.`,
        buttonCancel: "Abbrechen",
        buttonGo: "Beginnen",
      },
    ],
  },
];
